var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"no-shadow":""}},[_c('user-account-details-basic-information',{}),_c('vs-divider',{staticClass:"my-base",attrs:{"border-height":"2px"}}),_c('user-account-details-company-information')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }